export default "__VITE_ASSET__d826f284__"